<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ARTICLETOTAL from "@/config/total.js"
import TIMELINE from "@/config/time_line.js"

export default {
  name:"App",
    methods: {
      ...mapMutations(["setCategoryTotal", "setArticlesTotal", "setArticlesTimeline", "setLocalWeather"]),
      // 获取各个分类下文章数目
      async parserArticlesTotal(){
        let category = ARTICLETOTAL.category;
        let articles = ARTICLETOTAL.articles;
        let timeline = TIMELINE.timeLine;
        let _this = this;
        _this.setCategoryTotal(category);
        _this.setArticlesTotal(articles);
        _this.setArticlesTimeline(timeline);
      },
      // 获取本地天气
      async getWeather() {
        let _this = this;
        _this.$http.get('https://tianqiapi.com/api?version=v1&appid=76484249&appsecret=IKj68MGP&vue=1').then(
          res => {
            console.log('一周天气：', res.data)
            let response = res.data;
            let localCity = response.city || "杭州";
            let localCountry = response.country || "中国";
            let weatherData = response.data;
            let today = weatherData[0];
            let tomorrow = weatherData[1];
            let todayImg = 'http://tq.daodaoim.com//tianqiapi/skin/pitaya/' + today.wea_img +'.png';
            let todayWeather = '<span style="color:#EA80FC">'+today.wea+'</span>';
            let todayTemperature = '<span style="color:#EA80FC">'+today.tem+'</span>';
            let tomorrowImg = 'http://tq.daodaoim.com//tianqiapi/skin/pitaya/' + tomorrow.wea_img +'.png';
            let tomorrowWeather = '<span style="color:red">'+tomorrow.wea+'</span>';
            let tomorrowTemperature = '<span style="color:red">'+tomorrow.tem+'</span>';
            let update_time = response.update_time;
            let update_day = new Date(update_time).getDate();
            let data = {
              update_time:update_time,
              update_day:update_day,
              localCity:localCity,
              localCountry:localCountry,
              todayImg:todayImg,
              todayWeather:todayWeather,
              todayWeatherStr:today.wea,
              todayTemperatureStr:today.tem,
              todayTemperature:todayTemperature,
              tomorrowImg:tomorrowImg,
              tomorrowWeather:tomorrowWeather,
              tomorrowTemperature:tomorrowTemperature,
              tomorrowWeatherStr:tomorrow.wea,
              tomorrowTemperatureStr:tomorrow.tem,
            }
            this.setLocalWeather(data);
      }).catch((error) => {console.log('获取本地天气:', error);})
    },
  },
  mounted(){
    let _this = this;
    _this.parserArticlesTotal();
    _this.getWeather();
  }
}
</script>

<style lang="stylus" scoped>
@import url("./assets/font/font.css");
#app
  font-family "LiSu", "STKaiti", "KaiTi", "Microsoft YaHei"
  ::-webkit-scrollbar
    width 6px
    height 1px

  ::-webkit-scrollbar-thumb
    border-radius 6px
    background-color #DCEDC8
    background-image -webkit-linear-gradient(
     45deg,
     rgba(255, 255, 255, 0.2) 25%,
     transparent 25%,
     transparent 50%,
     rgba(255, 255, 255, 0.2) 50%,
     rgba(255, 255, 255, 0.2) 75%,
     transparent 75%,
     transparent
    )
  ::-webkit-scrollbar-track
    box-shadow inset 0 0 5px rgba(0, 0, 0, 0.2)
    background #ededed
    border-radius 6px
</style>